import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const authenticated = await authService.isLoggedIn();

  if (!authenticated) {
    authService.currentUser.set(undefined);
    authService.userIsAdmin.set(false);
    authService.userIsQiraAdmin.set(false);

    window.history.replaceState(null, '', '/login');

    await router.navigate(['/login'], { replaceUrl: true });
    return false;
  }
  return true;
};
